<template>
    <v-container :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
        <heading-view :right-column="true"></heading-view>

        <table-view></table-view>
        <role-edit-dialog></role-edit-dialog>

        <v-btn fab bottom right dark style="margin-bottom: 70px;"
               fixed color="primary" @click="dialog = true">
            <v-icon>mdi-arrange-send-backward</v-icon>
        </v-btn>

        <v-btn fab bottom right dark fixed color="accent" @click="showAddForm()">
            <v-icon>mdi-plus</v-icon>
        </v-btn>


        <v-dialog
                v-model="dialog"
                width="800">
            <v-card>
                <v-card-title
                        class="headline grey lighten-2"
                        primary-title>
                    Dodavanje permisija za tablicu
                </v-card-title>

                <v-card-text>
                    <v-text-field
                            v-model="form.table_name"
                            v-validate="'required'"
                            label="Naziv tablice u bazi.. (npr. users) *"
                            name="table_name"
                            type="text">
                    </v-text-field>

                    <v-text-field
                            v-model="form.title"
                            v-validate="'required'"
                            label="Naziv za prikaz tablice.. (npr. Korisnik) *"
                            name="title"
                            type="text">
                    </v-text-field>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="dialog = false">Odustani</v-btn>
                    <v-btn flat @click="addTablePermissions">Spremi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import {serverBus} from '../../main';

    import TableView from '../table/TableView';
    import HeadingView from '../heading/HeadingView'
    import RoleEditDialog from "../dialogs/RoleEditDialog";

    export default {

        components: {
            TableView,
            HeadingView,
            RoleEditDialog,
        },

        created: function () {
            this.$store.commit('setTable', this.table);

            this.show_add_view = this.$route.matched[0].name === 'AddView';
            this.show_table_view = this.$route.matched[0].name === 'TableView';

            serverBus.$on('show-add-form', (item) => {
                serverBus.$emit('show-add-edit-dialog', this.table, item);
            })
        },

        methods: {
            showAddForm: function () {
                serverBus.$emit('show-add-form', {id: -1});
            },

            addTablePermissions: function() {
                this.$axios.post('/ostalo/uloga/dozvola/dodaj_tablicu', this.form).then(() => {
                    serverBus.$emit('reload-table-data');

                    this.dialog = false;
                });
            }
        },

        beforeDestroy() {
            serverBus.$off('show-add-form');
        },

        data: function () {
            return {
                form: {},
                dialog: false,
                table: 'dozvola',
                show_add_view: false,
                show_table_view: false,
            };
        }
    }
</script>